import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useBankTransactions() {
  return useQuery({
    queryKey: ["bank_transactions"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("bank_transactions")
        .select("*")
        .order("date", { ascending: false });

      if (error) throw error;

      const cleaned = data?.map((tx) => {
        let amount = Number(tx.amount ?? 0);

        let type;
        if (tx.category === "Investment") {
          type = "Investment";
          // Keep amount sign as is for investments
        } else if (tx.category === "Credit Card Payment") {
          type = "Credit Card Payment";
          // Keep amount sign as is for credit card payments
        } else if (tx.category === "Income" || amount > 0) {
          type = "Income";
          if (amount < 0) amount = -amount; // Make income positive
        } else {
          type = "Expense";
          if (amount > 0) amount = -amount;
        }
        // Add other normalization as before

        return {
          ...tx,
          amount,
          date: tx.date ?? "",
          category: tx.category ?? "",
          description: tx.description ?? "",
          card: "Bank ACH",
          type,
        };
      }) || [];
      return cleaned;
    },
  });
}
